import { Button, Flex, Image, Text } from '@chakra-ui/react';
import { useGoogleLogin } from '@react-oauth/google';
import isEmpty from 'lodash/isEmpty';

import useAuth from '../../hooks/useAuth/useAuth';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';
import { extensionsRoutes } from '../../pages/Routes';
import { ToastContainer } from 'react-toastify';

const LoginWrapperWeb = () => {
  const { saveAuth, auth } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const login = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      console.log(tokenResponse);
      if (tokenResponse) {
        saveAuth(tokenResponse);
      }
    },
  });

  const from = location?.state?.from?.pathname || extensionsRoutes.Home;

  useEffect(() => {
    if (!isEmpty(auth)) {
      navigate(from, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth]);

  return (
    <Flex
      backgroundColor="#0c4a6e"
      height="100vh"
      alignItems="center"
      justifyContent="center"
    >
      <Flex
        height="fit-content"
        borderRadius="16px"
        justifyContent="center"
        alignItems="stretch"
        backgroundColor="#0A3150"
        className="w-5/6 lg:w-4/6"
      >
        <Image
          borderRadius="10px"
          width="66%"
          alt="Miva"
          objectFit="cover"
          src="/images/loginmiva_720.jpeg"
        />

        <Flex
          backgroundColor="white"
          borderRadius="16px"
          width="100%"
          padding="16px"
          display="flex"
          flexDir="column"
          alignItems="center"
          justifyContent="center"
          gap="8"
        >
          <Text
            fontWeight="bold"
            textAlign="center"
            fontSize={'24px'}
            className="text-center text-lg md:text-2xl xl:text-4xl"
          >
            Welcome to Miva Exam Watch !
          </Text>
          <Button
            id="login-google-acc-miva"
            _hover={{
              backgroundColor: '#0A3150',
              opacity: '0.8',
            }}
            backgroundColor="#0A3150"
            color="#ffffff"
            className="bg-primary-900 w-full max-w-xs"
            isLoading={false}
            onClick={() => login()}
            spinner={
              <svg
                className="h-5 w-5 animate-spin text-current"
                fill="none"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                />
                <path
                  className="opacity-75"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  fill="currentColor"
                />
              </svg>
            }
          >
            Login With Miva Email
          </Button>
        </Flex>
      </Flex>
      <ToastContainer position="bottom-right" />
    </Flex>
  );
};

export default LoginWrapperWeb;
